import React, {useEffect} from "react";
import holding from '../img/products/8593406.jpg';
import muassa from '../img/products/8878499.jpg';
import maas from '../img/products/8619.jpg';
import { useTranslation } from "react-i18next";
import "./products.css"; // Подключаем CSS для анимации
import "../i18n";



const FlipCardComponent = () => {
  const { t, i18n } = useTranslation();
 
   const changeLanguage = (lng) => {
     i18n.changeLanguage(lng);
     localStorage.setItem("lng", lng);
   };
 
   useEffect(() => {
     changeLanguage(localStorage.getItem("lng") || "en");
   }, []);

  const product = [
    {
      id: 1,
      image: holding,
      name: t("product1_header"),
      description: t("product1_text"),
      list1 : t("product1_list1"),
      list2 : t("product1_list2"),
      list3 : t("product1_list3"),
      list4 : t("product1_list4"),
      list5 : t("product1_list5"),
      list6 : t("product1_list6"),
      list7 : t("product1_list7"),
      list8 : t("product1_list8"),
      list9 : t("product1_list9"),
      list10 : t("product1_list10"),
      list11 : t("product1_list11"),
    },
    {
      id: 2,
      image: muassa,
      name: t("product2_header"),
      description: t("product2_text"), 
      list1 : t("product2_list1"),
      list2 : t("product2_list2"),
      list3 : t("product2_list3"),
      list4 : t("product2_list4"),
      list5 : t("product2_list5"),
      list6 : t("product2_list6"),
      list7 : t("product2_list7"),
      list8 : t("product2_list8"),
      list9 : t("product2_list9"),
    },
    {
      id: 3,
      image: maas,
      name: t("product3_header"),
      description: t("product3_text"),
      list1 : t("product3_list1"),
      list2 : t("product3_list2"),
      list3 : t("product3_list3"),
      list4 : t("product3_list4"),
      list5 : t("product3_list5"),
      list6 : t("product3_list6"),
    },
  ];
  
  
  return (
    <section id="products" className=" mx-auto sm:py-5  from-primary/100 to-primaryDark/70 backdrop-blur-lg bg-gradient-to-r">
      <div className="mx-auto flex justify-center px-4 sm:py-8 py-5  lg:max-w-7xl">
        <div className="flex flex-col gap-12 sm:gap-16">
          <h2 className="text-4xl text-white text-center font-semibold tracking-tight text-gray-950 sm:text-5xl lg:text-6xl">
           {t("products_header")}
          </h2>
          <div className="grid gap-12 sm:gap-16 lg:grid-cols-3">
            {product.map((service) => (
              <div
                key={service.id}
                className="group sm:h-[550px] sm:w-[400px] h-[450px] w-[300px] [perspective:1500px]"
              >
                <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
                  {/* Front Face */}
                  <div className="absolute inset-0 h-full w-full rounded-xl bg-white [backface-visibility:hidden]">
                    <img
                      src={service.image}
                      alt={service.name}
                      className=" sm:h-2/3 h-1/2 w-full object-contain rounded-t-xl"
                    />
                    <div className="p-4">
                      <h3 className="text-2xl font-semibold text-center">
                        {service.name}
                      </h3>
                      <p className="mt-2 text-center text-gray-600">
                        {service.description}
                      </p>
                    </div>
                  </div>
                  {/* Back Face */}
                  <div className="absolute sm:text-lg text-sm inset-0 h-full w-full rounded-xl bg-teal-900 shadow-md  text-white px-6 py-8 flex flex-col justify-center flip-card-face [transform:rotateY(180deg)] [backface-visibility:hidden]">
                  <ul className="list-disc space-y-0 sm:space-y-2 pl-4 ">
  {Object.keys(service)
    .filter((key) => key.startsWith('list'))
    .map((key) => (
      <li key={key}>{service[key]}</li>
    ))}
</ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlipCardComponent;
